module.exports = __webpack_public_path__ + "media/images/emblems/Ausserberg-d39fe6b3cf0e6a3d45f3726d270b6f0c.png";